import React, { useEffect, useState } from "react";
import axios from "axios";
import { Heart, Repeat } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Public "thank you" wall: donors whose paid contributions total $250+ (or board-featured).
// Donors with any monthly (recurring) gift carry a "Monthly Giver" badge.
export const DonorWall = () => {
    const [donors, setDonors] = useState([]);

    useEffect(() => {
        axios.get(`${API}/donors`).then(r => setDonors(r.data)).catch(() => {});
    }, []);

    if (!donors.length) return null;

    return (
        <section className="py-16 px-4 bg-[#2D5A27]" data-testid="donor-wall-section">
            <div className="max-w-5xl mx-auto text-center">
                <span className="font-marker text-[#C9A84C] text-2xl -rotate-1 inline-block mb-2">With Gratitude</span>
                <h2 className="font-anton text-4xl sm:text-5xl text-[#F5EDD6] uppercase leading-none mb-3">Our $250+ Donors</h2>
                <p className="font-manrope text-[#F5EDD6]/70 mb-10 max-w-2xl mx-auto">
                    Thank you to these generous supporters helping build a free, modern skatepark for Seeley Lake.
                </p>
                <div className="flex flex-wrap justify-center gap-3">
                    {donors.map((d, i) => (
                        <div key={d.name} data-testid={`donor-${i}`}
                            className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 bg-[#F5EDD6] border-2 border-[#C9A84C] px-4 py-2 shadow-[3px_3px_0px_0px_rgba(201,168,76,0.4)]">
                            <span className="flex items-center gap-2">
                                <Heart size={14} className="text-[#C4522A]" fill="#C4522A" />
                                <span className="font-manrope font-semibold text-[#3D2008]">{d.name}</span>
                            </span>
                            {d.monthly && (
                                <span data-testid={`donor-${i}-monthly-badge`}
                                    className="inline-flex items-center gap-1 bg-[#C9A84C] text-[#3D2008] font-manrope font-bold text-[10px] uppercase tracking-wide px-2 py-0.5 rounded-full">
                                    <Repeat size={10} /> Monthly Giver
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DonorWall;
